import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as feedAdviceActions from './feed-advice.actions';
import { FeedAdvice, FeedAdviceModuleState } from '../models/feed-advice.models';

function selectIdNumber(c: FeedAdvice): number {
  return c.id;
}
export const adapter: EntityAdapter<FeedAdvice> = createEntityAdapter<FeedAdvice>({
  selectId: selectIdNumber,
});

export const initialState = <FeedAdviceModuleState>{
  feedAdvices: adapter.getInitialState([]),
  isLoaded: false,
};
const feedAdviceReducer = createReducer(
  initialState,
  on(feedAdviceActions.clearFeedAdviceState, (state) => ({
    ...state,
    isLoaded: false,
    feedAdvices: adapter.removeAll(state.feedAdvices),
  })),
  on(feedAdviceActions.loadFeedAdvicesSuccess, (state, { feedAdvices }) => ({
    ...state,
    isLoaded: true,
    feedAdvices: adapter.setAll(feedAdvices, state.feedAdvices),
  })),
  on(feedAdviceActions.upsertFeedAdviceSuccess, (state, { feedAdvice }) => ({
    ...state,
    feedAdvices: adapter.upsertOne(feedAdvice, state.feedAdvices),
  })),
  on(feedAdviceActions.deleteAdviceSuccess, (state, { feedAdviceId }) => ({
    ...state,
    feedAdvices: adapter.removeOne(feedAdviceId, state.feedAdvices),
  })),
  on(feedAdviceActions.loadProductsByCountrySuccess, (state, { products }) => ({
    ...state,
    products,
  })),
  on(feedAdviceActions.loadReferenceSchemesByCountrySuccess, (state, { referenceSchemes }) => ({
    ...state,
    referenceSchemes,
  })),
  on(feedAdviceActions.setBaseFeedAdviceSuccess, (state, { feedAdvice }) => ({
    ...state,
    baseFeedAdvice: feedAdvice,
  })),
);

export function reducer(state: FeedAdviceModuleState | undefined, action: Action) {
  return feedAdviceReducer(state, action);
}
